import { render, staticRenderFns } from "./Add-Room.vue?vue&type=template&id=a241147e&"
import script from "./Add-Room.vue?vue&type=script&lang=js&"
export * from "./Add-Room.vue?vue&type=script&lang=js&"
import style0 from "./Add-Room.vue?vue&type=style&index=0&id=a241147e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports